import React from "react";
import utils from "../../universal/utils";
import { normalizeMatchNightRegion } from "./preferredMatchNight";

export default function useMatchNights({ country } = {}) {
  const [nights, setNights] = React.useState([]);
  const [preferredRegion, setPreferredRegion] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const hasLoadedRef = React.useRef(false);
  const basePath = React.useMemo(() => utils.getEdgeBasePath(), []);

  const fetchNights = React.useCallback(() => {
    if (!hasLoadedRef.current) setLoading(true);
    const params = country ? `?country=${encodeURIComponent(country)}` : "";
    return fetch(`${basePath}/api/v1/public/match-nights${params}`, { credentials: "omit" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data?.ok) {
          setNights(data.items || []);
          setPreferredRegion(normalizeMatchNightRegion(data.preferredRegion));
        }
      })
      .catch(() => {})
      .finally(() => {
        hasLoadedRef.current = true;
        setLoading(false);
      });
  }, [basePath, country]);

  React.useEffect(() => {
    let cancelled = false;
    fetchNights().then(() => {
      if (cancelled) return;
    });
    return () => {
      cancelled = true;
    };
  }, [fetchNights]);

  return { nights, preferredRegion, loading, basePath, refetch: fetchNights };
}
